kombi.spinner = function(button) {
    if (!button) {
        return; 
    }

    const currentHeight = button.offsetHeight;
    button.style.minHeight = currentHeight + 'px'; 

    button.classList.add('disabled');
    var buttonText = button.querySelector('.buttonText');
    if (buttonText) {
        buttonText.classList.add('d-none');
    }
    var spinner = button.querySelector('.buttonSpinner');
    if (spinner) {
        spinner.classList.remove('d-none');
    }
}

kombi.resetButton = function(button) {
    if (!button) return;

    button.classList.remove('disabled');

    const buttonText = button.querySelector('.buttonText');
    if (buttonText) {
        buttonText.classList.remove('d-none');
    }

    const spinner = button.querySelector('.buttonSpinner');
    if (spinner) {
        spinner.classList.add('d-none');
    }

    button.style.minHeight = ''; 
}